import { PageHeader } from '@loop3/ui'
import { trips } from '@/content/trips/manifest'
import { TripCard } from '@/components/trip-card'

const PAGE_EYEBROW = 'Knowledge Hub · Trips'
const PAGE_TITLE = 'Trips'
const PAGE_SUBTITLE =
  'Artifacts from Loop3 team trips and mixed-firm working weeks. Each card opens the trip dashboard in a new tab.'

export function TripsIndexPage() {
  return (
    <div className="mx-auto max-w-7xl pb-16">
      <PageHeader
        eyebrow={PAGE_EYEBROW}
        title={PAGE_TITLE}
        subtitle={PAGE_SUBTITLE}
      />
      {trips.length === 0 ? (
        <div className="mt-10 border border-dashed border-border rounded-lg p-10 text-center">
          <p className="text-sm opacity-70">
            No trips yet. Add one to{' '}
            <code className="font-mono text-xs">
              platform/app/src/content/trips/manifest.ts
            </code>
            .
          </p>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {trips.map((trip) => (
            <TripCard key={trip.slug} trip={trip} />
          ))}
        </div>
      )}
    </div>
  )
}
